import React from "react";
import { Container, Box, makeStyles, Grid, Divider } from "@material-ui/core";
import Logo from "../assets/images/logo.PNG";
import { useHistory } from "react-router-dom";
import SlideDownModal from "../components/reusableComponents/SlideDownModal";
import Footer from "./Desktop/Footer";
import SearchEngine from "../form/SearchEngine";
import TransactionHistory from "../components/reusableComponents/TransactionHistory";
import HeaderSection from "../components/reusableComponents/HeaderSection";
import ChangePasswordForm from "../components/reusableComponents/ChangePasswordForm";
import { useSelector } from "react-redux";
const useStyles = makeStyles(() => ({
  item: {
    //   backgroundColor: "#ee8622",
    display: "flex",
    listStyle: "none",
    marginBottom: 0,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#ee8622",
    },
  },
  li: {
    color: "white",
    padding: "4px 8px",
    background: "no-repeat",
    borderRight: "none",
  },
  card: {
    padding: 30,
    background: "rgba(62, 29, 28, 0.9)",
    "&:hover": {
      // backgroundColor: "#ee8622",
      boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
    },
  },
}));
const MyProfile = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [header, SetHeader] = React.useState("onlineRecharge");
  const {agentlogin}=useSelector((state)=>state.user)
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handelHeader = (val) => {
    SetHeader(val);
  };
  return (
    <div>
    <HeaderSection/>
      <Divider style={{ background: "#0f3f5a" }} />
      <Container style={{ paddingLeft: 50, paddingRight: 50, paddingTop: 50 }}>
        <p
          style={{
            textAlign: "center",
            color: "rgb(15, 63, 90)",
            fontSize: 30,
            fontWeight: "bold",
          }}
        >
          My Profile
        </p>

        <Grid container style={{ marginTop: 30 }} spacing={2}>
          <Grid item xs={12} lg={4}></Grid>
          
          {/* <Grid item xs={3}>
            <Box
              style={{
                boxShadow: "0 5px 15px rgba(0,0,0,.1)",
                padding: 20,
                borderLeft: "1px solid #52ee22!important",
              }}
            >
              <span style={{ color: "#000", fontSize: 24, fontWeight: "bold" }}>
                ABC BANK
              </span>
              <Box>
                <span>Branch: ABC Branch</span>
                <br></br>
                <span>Account Number: ABC Branch</span>
                <br></br>
                <span>Account Holder: ABC</span>
                <br></br>
                <span>IFSC Code: BJUI654</span>
              </Box>
            </Box>
          </Grid> */}
          <Grid item xs={12} lg={4}>
          <Divider style={{ background: "#0f3f5a" }} />
          <Box style={{display:'flex',justifyContent:'space-between',padding:10}}>
            <span>Name:</span>
            <span>{agentlogin&&agentlogin?.result?.result?.name}</span>
          </Box>
          <Divider style={{ background: "#0f3f5a" }} />
          <Box style={{display:'flex',justifyContent:'space-between',padding:10}}>
            <span>Company Name:</span>
            <span>{agentlogin&&agentlogin?.result?.result?.agencyName}</span>
          </Box>
          <Divider style={{ background: "#0f3f5a" }} />
          <Box style={{display:'flex',justifyContent:'space-between',padding:10}}>
            <span>Email:</span>
            <span>{agentlogin&&agentlogin?.result?.result?.email}</span>
          </Box>
          <Divider style={{ background: "#0f3f5a" }} />
          <Box style={{display:'flex',justifyContent:'space-between',padding:10}}>
            <span>Mobile:</span>
            <span>{agentlogin&&agentlogin?.result?.result?.phone}</span>
          </Box>
          <Divider style={{ background: "#0f3f5a" }} />
          <Box style={{display:'flex',justifyContent:'space-between',padding:10}}>
            <span>Address:</span>
            
          </Box>
          <Divider style={{ background: "#0f3f5a" }} />
          </Grid>
          <Grid item xs={12} lg={4}></Grid>
          {/* <Grid item xs={3}></Grid> */}
        </Grid>
      </Container>
     
      <Footer />
    </div>
  );
};

export default MyProfile;
